import React from "react";
import "./Floatinwapp.css";

const Floatinwapp = () => {

  const groupLink = "https://chat.whatsapp.com/ELwXxbNZw9C55GsOQBivVA";

  return (
    <div
      className={`floating-whatsapp`}
      onClick={() => window.open(groupLink, "_blank")}
      title="Join our WhatsApp Group"
    >
      <img
        src="wapp.png"
        alt="Join WhatsApp Group"
        className="whatsapp-icon"
      />
    </div>
  );
};

export default Floatinwapp;
